import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';

// api
import { remove } from '../../sources/api/client';
import concernCategoryService from '../../sources/api/concernCategoryService';

// constants
import { CONCERN_CATEGORY_REMOVE, CONCERN_CATEGORY_REMOVE_INIT } from '../../constants/concernCategoryTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { concernCategorySchema } from '../../schemas/concernCategory';

export function* concernCategoryRemove(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const { id } = action.payload || {};

  try {
    yield* httpSaga(CONCERN_CATEGORY_REMOVE, call(remove, concernCategoryService, id), {
      schema: concernCategorySchema,
    });
  } catch (err) {
    yield put(error(CONCERN_CATEGORY_REMOVE, err));
  } finally {
    yield put(doneIndicator(CONCERN_CATEGORY_REMOVE));
  }
}

export function* watchConcernCategoryRemove() {
  yield takeEvery(CONCERN_CATEGORY_REMOVE_INIT, concernCategoryRemove);
}

export default function* root() {
  yield all([
    fork(watchConcernCategoryRemove),
  ]);
}
